import { type ReactNode } from 'react';
import useAuthInitializer from './useAuthInitializer';
import type { IApiConfig } from '../config/Config';
import AuthContext from './AuthContext';

const AuthProvider = ({ children, apiConfig }: { children: ReactNode; apiConfig: IApiConfig }) => {
  const [userAccount, getAuthToken] = useAuthInitializer(apiConfig);

  if (!userAccount || !getAuthToken) return null;

  const authValues = {
    getAuthToken,
    userAccount,
  };

  return <AuthContext.Provider value={authValues}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
